export var TeamLiveReportsRoutes = {
    "/time-card-edits-report": {
        "name": "appLayout.schedule.reports.time-card-edits-report",
        "route_dependencies": [
            {
                type: 'chunk',
                loader: function () {
                    return import("./team-live_reports.module.js");
                }
            }
        ]
    }
}